export const getEmptyArrayFromLength = (length) => Array.from({ length });
